// extracted by mini-css-extract-plugin
export var root = "index-module--root--275rq";
export var cols = "index-module--cols--20s2_";
export var right = "index-module--right--2bc0O";
export var intro = "index-module--intro--dsnG9";
export var outro = "index-module--outro--2U3zR";